import { gql } from '@apollo/client';

export const SEND_PHONE_OTP = gql`
  mutation SendPhoneOtp($phoneNumber: String!) {
    sendPhoneOtp(phoneNumber: $phoneNumber)
  }
`;

export const VERIFY_PHONE_OTP = gql`
  mutation VerifyPhoneOtp($phoneNumber: String!, $code: String!) {
    verifyPhoneOtp(phoneNumber: $phoneNumber, code: $code) {
      id
      email
      phoneNumber
      isPhoneVerified
      firstName
      lastName
      displayName
    }
  }
`;
